import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import SendIcon from '@mui/icons-material/Send';

const ManualGoalModal = ({
  isOpen,
  onClose,
  description,
  type,
  onDescriptionChange,
  onTypeChange,
  onSubmit,
  loading,
  error,
  clientName, // Added to personalize the title
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Propose New Goal to {clientName || 'Client'}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          autoFocus
          margin="dense"
          id="manualGoalDescription"
          label="Goal Description"
          type="text"
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          value={description}
          onChange={onDescriptionChange}
          sx={{ mb: 2 }}
          disabled={loading}
        />
        <FormControl fullWidth size="small" disabled={loading}>
          <InputLabel id="manual-goal-type-label">Goal Type</InputLabel>
          <Select
            labelId="manual-goal-type-label"
            id="manualGoalType"
            value={type}
            label="Goal Type"
            onChange={onTypeChange}
          >
            <MenuItem value="one_off">One-off Task</MenuItem>
            <MenuItem value="habit">Habit</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button 
          onClick={onSubmit} 
          variant="contained" 
          disabled={loading || !description.trim()}
          startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <SendIcon />}
        >
          Send Proposal
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManualGoalModal;
